import { Link, useParams } from 'react-router-dom';
import { trendingArticles } from '@/mocks/articles';

export default function CategoryGrid() {
  const { slug } = useParams<{ slug: string }>();
  const articles = trendingArticles.filter((a) => a.category === slug);

  if (articles.length === 0) {
    return (
      <section className="w-full py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto text-center">
          <i className="ri-inbox-line text-5xl text-foreground-300"></i>
          <p className="text-foreground-400 mt-4">该分类暂无内容，敬请期待</p>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`911爆料网 - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {article.heat > 9999
                      ? `${(article.heat / 10000).toFixed(1)}万热度`
                      : `${article.heat}热度`}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex flex-wrap gap-1.5 mb-2">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-2 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/60">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}